<template>
    <div class="text-sm">
        <span class="text-base text-info font-medium">Détails du client</span>
        <div class="md-layout md-gutter mt-3">
            <div class="md-layout-item md-size-100">
                <div>
                    <span class="font-medium">Nom :</span>
                    <span class="ml-1">{{ client.name }}</span>
                </div>
                <div class="w-1/2">
                    <span class="font-medium">Contacts :</span>
                    <template v-if="selectedContacts(client.contacts).length > 0">
                        <client-contacts-selected :contacts="selectedContacts(client.contacts)"></client-contacts-selected>
                    </template>
                    <span v-else class="ml-1">Aucun</span>
                </div>
            </div>
        </div>
        <md-divider class="my-3"></md-divider>
        <div class="md-layout md-gutter mt-3">
            <div class="md-layout-item md-size-100">
                <span class="text-base font-medium">Demandes</span>
                <demands v-if="client.id" :clientId="client.id" :route="false" style="margin: -16px -16px 10px;"></demands>
            </div>
        </div>
    </div>
</template>

<script>
import ClientContactsSelected from "@/pages/Clients/Informations/components/ClientContactsSelected";
import Demands from "@/pages/Clients/Demandes/Demands";
export default {
    name: "TabClient",
    components: {
        ClientContactsSelected, Demands
    },
    props: {
        interventionId: Number,
        active: Boolean
    },
    data() {
        return {
            client: {}
        }
    },
    methods: {
        async getClientDetails() {
            const { data } = await this.$store.dispatch('calendar/getModalClient', {
                interventionId: this.interventionId
            })
            this.client = data.client
        },
        selectedContacts(contacts = []) {
            return contacts.filter(contact => contact.is_selected)
        },
    },
    mounted() {
        if(this.active) {
            this.getClientDetails()
        }
    },
    watch: {
        active(newVal) {
            if(newVal) {
                this.getClientDetails()
            }
        }
    }
}
</script>

<style scoped>

</style>
